import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const Bar = styled.div`
  position: fixed;
  height: 5px;
  width: 100%;
  z-index: 10000;
  top:0;
  left: 0;

  #nprogress {
    .bar {
      height: 10px;
    }
  }
`

export default function ProgressBar({ start }) {
  NProgress.configure({
    parent: '#topbar',
    easing: 'ease',
    speed: 200,
  })

  useEffect(() => {
    if (start) {
      NProgress.start()
    } else {
      NProgress.done()
    }

    return (() => NProgress.done())
  }, [start])

  return (
    <Bar id="topbar" />
  )
}

ProgressBar.propTypes = {
  start: PropTypes.bool,
}

ProgressBar.defaultProps = {
  start: false,
}
